import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, Paper, Typography, TextField, Button,
  Grid, Box, Alert, Link, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox
} from '@mui/material';
import { api } from '../services/api';
import { auth } from '../utils/auth';
import { LATIN_AMERICAN_COUNTRIES } from '../constants/countries';
import WelcomeBusiness from '../assets/WelcomeBusiness2.jpg';
import { Link as RouterLink } from 'react-router-dom';

const SignUpBusiness = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    legalName: '',
    taxId: '',
    email: '',
    password: '',
    confirmPassword: '',
    country: 'AR',
    contactInfo: {
      phone: '',
      address: ''
    }
  });
  const [acceptTerms, setAcceptTerms] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: { ...prev[parent], [child]: value }
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }
    if (!acceptTerms) {
      setError('Debe aceptar los términos y la política de privacidad');
      return;
    }

    try {
      const response = await api.registerBusiness({
        name: formData.name,
        legalName: formData.legalName,
        taxId: formData.taxId,
        email: formData.email,
        password: formData.password,
        country: formData.country,
        contactInfo: formData.contactInfo
      });
      
      // Store email for verification pending page
      localStorage.setItem('pendingVerificationEmail', formData.email);

      auth.setCredentials(
        response.token,
        'business',
        response.business.name,
        response.business
      );

      // Redirect to verification pending page if verification is required
      if (response.requiresVerification) {
        navigate('/verification-pending');
      } else {
        navigate('/');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Error al registrarse');
    }
  };

  return (
    <Container sx={{ padding: {xs:'5% 0 0 0', md:'0px !important'}, backgroundColor:'#F4F4F4' }} component="main" maxWidth="100vw">
      <Grid container sx={{ 
        minHeight: 'calc(100vh - 106px)',
        transition: 'all 0.3s ease-in-out',
        justifyContent: {xs:'center', sm:'center', md:'start', lg:'start'},
      }}>
        <Grid item xs={0} sm={0} md={5} lg={5} sx={{
          transition: 'all 0.1s ease-in-out',
          padding: '0px !important'
        }}>
          <Box sx={{ 
            backgroundColor: '#FF6B00', 
            backgroundImage: `url(${WelcomeBusiness})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '100%',
            transition: 'all 0.1s ease-in-out'
          }} />
        </Grid>
        
        <Grid item xs={12} sm={9} md={7} lg={7} sx={{
          transition: 'all 0.3s ease-in-out',
          padding: '0px !important'
        }}>
          <Box 
            sx={{ 
              px: { xs: '5%', sm: '10%', md: '20%', lg: '30%' }, 
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              transition: 'all 0.3s ease-in-out'
            }}
          >
            <Typography component="h1" variant="h5" align="center" gutterBottom>
              Registrarse como comprador
            </Typography>

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    label="Nombre comercial o nombre propio"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    
                    fullWidth
                    label="Razón Social"
                    name="legalName"
                    value={formData.legalName}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="CUIT/RUT"
                    name="taxId"
                    value={formData.taxId}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                <FormControl fullWidth sx={{
                    '@media (max-width:1366px)': {
                      fontSize: '0.95rem',
                    }
                  }}>
                    <InputLabel>País</InputLabel>
                    <Select
                      sx={{
                        fontSize: '0.95rem',
                      }}
                      required
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      label="País"
                    >
                      {Object.entries(LATIN_AMERICAN_COUNTRIES).map(([code, name]) => (
                        <MenuItem key={code} value={code}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Teléfono"
                    name="contactInfo.phone"
                    value={formData.contactInfo.phone}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Dirección"
                    name="contactInfo.address"
                    value={formData.contactInfo.address}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Contraseña"
                    name="password"
                    type="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Confirmar Contraseña"
                    name="confirmPassword"
                    type="password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={acceptTerms}
                        onChange={(e) => setAcceptTerms(e.target.checked)}
                      />
                    }
                    label={
                      <Typography variant="body2">
                        Acepto los{' '}
                        <RouterLink 
                          to="/terms-and-services" 
                          target="_blank" 
                          rel="noopener noreferrer"
                        >
                          términos
                        </RouterLink>
                        {' '}y la{' '}
                        <RouterLink 
                          to="/privacy-policy" 
                          target="_blank" 
                          rel="noopener noreferrer"
                        >
                          política de privacidad
                        </RouterLink>.
                      </Typography>
                    }
                  />
                </Grid>
              </Grid>

              {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {error}
                </Alert>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Continuar
              </Button>

              <Box sx={{ textAlign: 'center' }}>
                <Link 
                  component="span"
                  variant="body2"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/signup-distributor');
                  }}
                  sx={{ cursor: 'pointer' }}
                >
                  ¿Querés vender? Regístrate aquí
                </Link>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SignUpBusiness; 